import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
  Tabs,
  Tab,
  Avatar,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  Select
} from "@mui/material";
import { CloudUpload, Download, MoreVert, Upload } from "@mui/icons-material";
import { Container } from "shards-react";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import ReusableModal from "../components/components-overview/Model";

const UserManagement = () => {
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [loadingUser, setLoadingUser] = useState(false);
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState({
      register: false
  });
  const [addUser, setAdduser] = useState();

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    role: "",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleAddUser = async () => {

    const payload = {
      ...(data.email && { email: data.email }),
      ...(data.password && { password: data.password }),
      ...(data.name && { display_name: data.name }),
      ...(data.phone && { phone_number: `+91${data.phone}` }),
      ...(data.role && { role: data.role }),
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/create/user`,
        payload ,{
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}` // Replace with your token source
          }
        }
      );
      if (response.data.status == "success") {
        setAdduser(response.data.message);
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
        setData({
          name: "",
          email: "",
          password: "",
          phone: "",
          role: "",
        });
      } else {
        setMessage(response.data.message);
        setSeverity("warning");
        setOpen(true);
      }

    } catch (err) {
      setMessage(error.response.data.error);
      setSeverity("error");
      setOpen(true);
      console.log(err);
    }
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const columns = [
    {
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: params => params.api.getAllRowIds().indexOf(params.id) + 1
    },

    {
      field: "photo_url",
      headerName: "photo_url",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Photo"}</strong>
      ),
      renderCell: params => {
        return <Avatar src={params.row.photo_url} />;
      }
    },

    {
      field: "display_name",
      headerName: "display_name",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Name"}</strong>
      )
    },

    {
      field: "email",
      headerName: "Email",
      width: 220,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Email"}</strong>
      )
    },
    {
      field: "creation_time",
      headerName: "creation_time",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Created At "}</strong>
      )
    },
    {
      field: "last_login_time",
      headerName: "Last Login",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Last Login"}</strong>
      )
    },
    {
      field: "last_refresh_time",
      headerName: "last_refresh_time",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Last Refreshed"}
        </strong>
      )
    },

    {
      field: "email_verified",
      headerName: "email_verified",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Email Verified"}
        </strong>
      )
    },
    {
      field: "role",
      headerName: "email_verified",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Role"}</strong>
      )
    }
  ];

  useEffect(() => {
    const fetchData = async () => {
      // const response = await axios.get(`${process.env.REACT_APP_CORE_URL}/api/user_details`);
      try {
        setLoadingUser(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/get/user/registered`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}` // Replace with your token source
            }
          }
        );
        if (response.data.status == "success") {
          console.log(response.data.message);

          let filtered_data = response.data.message.filter((curr)=>  curr.role == "admin" || curr.role == 'superAdmin' || curr.role == 'Expert')
          
          setUsers(filtered_data);
          setLoadingUser(false);
        }
      } catch (err) {
        console.log(err);
      }finally{
        setLoadingUser(false);

      }
    };
    fetchData();
  }, [addUser]);

  return (
    <Container
      fluid
      className="main-content-container px-4 py-4"
      style={{ backgroundColor: "white" }}
    >
      <Grid container>
      <Grid item xs={12}><Button
            variant="contained"
            style={{ marginBottom: 16, borderRadius: 25, fontSize: 11 }}
            onClick={()=> setOpenModal((prev)=> ({...prev, register: true }))}
          >
            Register New User
          </Button></Grid>
          <Grid item xs={12}>
          <DataGrid
            getRowId={row => row.email}
            rows={users}
            columns={columns}
            style={{ minHeight: 200, maxHeight: 600 }}
            loading={loadingUser}
            rowSelection={false}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 30]}
            components={{ Toolbar: GridToolbar }}
            pagination
          />
        </Grid>
      </Grid>

      <ReusableModal
          width="50.083vw"
          height = "80%"
           open={openModal['register']}
           onClose={() => setOpenModal((prev)=> ({...prev, register: false }))}
         >
           <Box>
           <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      required
                      label="Name"
                      name="name"
                      value={data.name}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      required
                      label="Email"
                      name="email"
                      value={data.email}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      required
                      label="Password"
                      type="password"
                      name="password"
                      value={data.password}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Phone Number"
                      name="phone"
                      value={data.phone}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                  <FormControl
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    sx={{ gap: 2 }}
                  >
                    <InputLabel id="demo-select-small-label">Role</InputLabel>

                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      label="Role"
                      name="role"
                      value={data.role}
                      onChange={(e) => handleChange(e)}
                      style={{ width: 445 }}
                    >
                      <MenuItem value="Expert">Expert</MenuItem>
                      <MenuItem value="admin">Admin</MenuItem>
                      <MenuItem value="user">User</MenuItem>
                    </Select>
                  </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                  <Button variant="contained" onClick={handleAddUser}>
                  Register
                </Button>
                </Grid>
                </Grid>
           </Box>
         </ReusableModal>


      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default UserManagement;
